import { useEffect, useState } from "react";

/**
 * Floating fullscreen card offsets (giống /drives/list): tính top dưới navbar/banner
 * và left sau sidebar để dựng 1 card position:fixed lấp đầy vùng còn lại.
 * (Copy từ crm/payment-request/common — dùng chung cho Purchase Requisition + Purchase Order.)
 */
export default function usePageOffsets() {
  const [offsets, setOffsets] = useState({ top: 60, left: 0, right: 0, bottom: 0 });

  useEffect(() => {
    const calc = () => {
      const navbarTop = document.querySelector(".ptl-navbar-top");
      const navbarVertical = document.querySelector(".ptl-navbar-vertical");
      const banner = document.querySelector(".release-notification-banner");

      const topNavBottom = navbarTop ? navbarTop.getBoundingClientRect().bottom : 0;
      const bannerBottom = banner ? banner.getBoundingClientRect().bottom : 0;
      const top = Math.max(topNavBottom, bannerBottom, 60);

      const sidebar = navbarVertical?.getBoundingClientRect();
      const left = sidebar && sidebar.right > 0 && sidebar.width < window.innerWidth ? sidebar.right : 0;

      setOffsets({ top, left, right: 0, bottom: 0 });
    };
    calc();
    const t = setTimeout(calc, 150);
    window.addEventListener("resize", calc);
    const sb = document.querySelector(".ptl-navbar-vertical");
    let mo;
    if (sb && window.MutationObserver) {
      mo = new window.MutationObserver(calc);
      mo.observe(sb, { attributes: true, attributeFilter: ["class", "style"] });
    }
    return () => {
      clearTimeout(t);
      window.removeEventListener("resize", calc);
      mo?.disconnect();
    };
  }, []);

  return offsets;
}
